const asArray = (value) => Array.isArray(value) ? value : [];
const asText = (value) => value === null || value === undefined ? "" : String(value);
const asId = (value) => asText(value);
const PHOTOGRAPHY_CATALOG_STATUS = Object.freeze({
    IDLE: "idle",
    LOADING: "loading",
    READY: "ready",
    EMPTY: "empty",
    SESSION_EXPIRED: "sessionExpired",
    ERROR: "error",
});

const asMoney = (value) => {
    const amount = Number(value);
    return Number.isFinite(amount) && amount >= 0 ? amount.toFixed(2) : null;
};

const normalizeImageUrls = (value) => asArray(value)
    .filter((url) => typeof url === "string" && url);

const normalizePackage = (item = {}) => ({
    versionId: asId(item.versionId),
    name: asText(item.name),
    amount: asMoney(item.amount),
    standard: item.standard === true,
});

const normalizeStyle = (item = {}) => {
    const packages = asArray(item.packages).map(normalizePackage);
    const amounts = packages
        .filter((entry) => entry.amount !== null)
        .map((entry) => Number(entry.amount))
        .filter((amount) => Number.isFinite(amount));
    const showcaseImageUrls = normalizeImageUrls(item.showcaseImageUrls);
    const detailImageUrls = normalizeImageUrls(item.detailImageUrls);

    return {
        id: asId(item.id),
        name: asText(item.name),
        serviceItemId: asId(item.serviceItemId),
        showcaseImageUrls,
        detailImageUrls,
        coverImageUrl: showcaseImageUrls[0] || detailImageUrls[0] || "",
        packages,
        startingAmount: amounts.length ? Math.min(...amounts).toFixed(2) : null,
    };
};

const normalizeTheme = (item = {}) => {
    const styles = asArray(item.styles).map(normalizeStyle);
    const amounts = styles
        .map((style) => Number(style.startingAmount))
        .filter((amount) => Number.isFinite(amount));
    const coverStyle = styles.find((style) => style.coverImageUrl);
    const startingPrice = item.startingPrice === undefined
        ? (amounts.length ? Math.min(...amounts) : null)
        : item.startingPrice;
    return {
        id: asId(item.id),
        name: asText(item.name),
        coverImageUrl: asText(item.coverImageUrl) || (coverStyle ? coverStyle.coverImageUrl : ""),
        startingAmount: asMoney(startingPrice),
        styles,
    };
};

const normalizeThemeType = (item = {}) => ({
    id: asId(item.id),
    name: asText(item.name),
    campusQualificationRequired: item.campusQualificationRequired === true,
    themes: asArray(item.themes).map(normalizeTheme),
});

const normalizePhotographyCatalog = (payload) => ({
    themeTypes: asArray(payload && payload.themeTypes).map(normalizeThemeType),
});

const normalizePhotographyThemeDetail = (payload = {}) => {
    const themeTypeName = asText(payload.themeTypeName);
    const themeName = asText(payload.themeName);
    const campusQualificationRequired = payload.campusQualificationRequired === true;
    return {
        themeTypeId: asId(payload.themeTypeId),
        themeId: asId(payload.themeId),
        themeTypeName,
        themeName,
        campusQualificationRequired,
        serviceItems: asArray(payload.serviceItems).map((item = {}) => {
            const showcaseImageUrls = normalizeImageUrls(item.showcaseImageUrls);
            const detailImageUrls = normalizeImageUrls(item.detailImageUrls);
            return {
                serviceItemId: asId(item.serviceItemId),
                styleId: asId(item.styleId),
                styleName: asText(item.styleName),
                themeTypeName,
                themeName,
                campusQualificationRequired,
                makeupAmount: asMoney(item.makeupAmount),
                extraPersonAmount: asMoney(item.extraPersonAmount),
                showcaseImageUrls,
                detailImageUrls,
                coverImageUrl: showcaseImageUrls[0] || detailImageUrls[0] || "",
                packages: asArray(item.packages).map(normalizePackage),
            };
        }),
    };
};

const getCatalogRequestState = (error) => {
    const response = error && error.response;
    const responsePayload = response && response.data;
    const codes = [responsePayload && responsePayload.code, response && response.status, error && error.code];
    return codes.some((code) => Number(code) === 401)
        ? PHOTOGRAPHY_CATALOG_STATUS.SESSION_EXPIRED
        : PHOTOGRAPHY_CATALOG_STATUS.ERROR;
};

module.exports = {
    getCatalogRequestState,
    normalizePhotographyCatalog,
    normalizePhotographyThemeDetail,
    PHOTOGRAPHY_CATALOG_STATUS,
};
